<template>

    <div class="form-group" :class="{ 'column': options.column, 'no-margin': options.noMargin, 'less-margin': options.lessMargin }">
        <label :for="formData.name" v-show="formData.label">
            <span v-html="formData.label"></span>
            <sup v-if="options && options.required"> *</sup>
        </label>
        <input type="hidden" :name="formData.name" :value="selectedValue">
        <div class="form-component">
            <div
                class="toggle-box"
                @keydown.space.prevent="toggleWithSpace"
                :class="{
                    'small' : options && options.size && options.size === 'small' ,
                    'tiny' : options && options.size && options.size === 'tiny',
                    'disabled': options && options.disabled,
                }"
            >
                <div
                    tabindex="0"
                    class="toggle-item"
                    :class="{ selected: item.value === selectedValue }"
                    v-for="(item, index) in data"
                    @keydown="event => onKeydown(event, item.value)"
                    @click="toggle(item.value)"
                    v-html="item.text"
                    :data-value="item.value"
                ></div>
            </div>
        </div>
    </div>

</template>

<script>

    export default {
        name: "GroupToggle",

        props: ['formData', 'data', 'options'],

        data() {
            return {
                selectedValue: null,
            }
        },

        created() {
            this.selectedValue = this.formData.value ?? this.selectedValue;
        },

        methods: {

            toggle(value) {
                if (this.options && this.options.disabled) {
                    return;
                }

                this.selectedValue = value;
                this.handleChange();
            },

            toggleWithSpace(event) {
                event.preventDefault();
                this.toggleNext();
            },

            toggleNext() {
                const currentIndex = this.data.findIndex(item => item.value === this.selectedValue);
                const nextIndex = (currentIndex + 1) % this.data.length;
                this.toggle(this.data[nextIndex].value);
            },

            onKeydown(event, value) {
                 if (event.key === 'Enter') {
                    this.toggle(value);
                }
            },

            handleChange: function() {

                //remove validation message
                this.Bus.emit('hide-validation-message', this.formData.name);
                this.Bus.emit('hide-flash-message');

                //emit change
                if (! this.options.silent) {
                    this.Bus.emit('form-toggle-changed', {
                        name: this.formData.name,
                        value: this.selectedValue
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>
